import { SchemaVersionError } from "../errors";
import type { LabelTemplateV2, SchemaVersion } from "../types/template";

const SUPPORTED_SCHEMA_VERSION: SchemaVersion = "2.0";

export function assertTemplateSchemaVersion(template: {
  schemaVersion: unknown;
}): asserts template is LabelTemplateV2 {
  if (template.schemaVersion !== SUPPORTED_SCHEMA_VERSION) {
    throw new SchemaVersionError(
      SUPPORTED_SCHEMA_VERSION,
      template.schemaVersion,
    );
  }
}
